import { Flex, useBreakpointValue } from '@chakra-ui/react'
import React from 'react'
import { MobileSessionDrawer } from '../../components/mobile-assist-drawer'
import { ParticipantList } from './components/participant-list'
import { SidePanel } from './components/side-panel'
import { useActiveTelehealthSession } from './context/active-telehealth-session.context'
import { LayoutManager } from './layouts'

export const ClientActiveCall = () => {
  const { isSidebarVisible, activeSidebarTab, toggleSidebar } =
    useActiveTelehealthSession()

  const isSmallScreen = useBreakpointValue({ base: true, sm: true, md: false })

  return (
    <>
      <Flex w="100%" h="100%" flexDirection="row">
        <LayoutManager />
        {!isSmallScreen && (
          <SidePanel isVisible={isSidebarVisible}>
            {activeSidebarTab === 'participants' && (
              <ParticipantList
                user={null}
                onClose={() => toggleSidebar(activeSidebarTab)}
              />
            )}
          </SidePanel>
        )}
      </Flex>
      {isSmallScreen && (
        <MobileSessionDrawer isOpen={isSidebarVisible}>
          <>
            {activeSidebarTab === 'participants' && (
              <ParticipantList
                user={null}
                onClose={() => toggleSidebar(activeSidebarTab)}
              />
            )}
          </>
        </MobileSessionDrawer>
      )}
    </>
  )
}
